import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=de5d7686&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=de5d7686&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5d7686",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de5d7686')) {
      api.createRecord('de5d7686', component.options)
    } else {
      api.reload('de5d7686', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=de5d7686&scoped=true", function () {
      api.rerender('de5d7686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/ResetPassword.vue"
export default component.exports